const debugWindow = document.querySelector('#debug_window');

if (debugWindow) {

    const closeBtn = debugWindow.querySelector('[data-action="close"]');
    const openBtns = document.querySelectorAll('[data-action="open-debug-window"]');
    
    let lastFocus;
    
    openBtns?.forEach(openBtn => {
    
        openBtn.addEventListener('click', () => {
    
            lastFocus = document.activeElement;
            debugWindow.hidden = false;
            debugWindow.open = true;
            debugWindow.querySelector('input')?.focus();
            document.body.style.overflow = 'hidden'; // bloque le scroll
    
            openBtn.setAttribute('aria-expanded', 'true');
            
        });
    
    });
    
    closeBtn.addEventListener('click', closeDebugWindow);
    
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeDebugWindow();
    });
    
    function closeDebugWindow() {
        
        debugWindow.hidden = true;
        debugWindow.open = false;    
        
        lastFocus?.focus();
    
        openBtns?.forEach(openBtn => openBtn.setAttribute('aria-expanded', 'false'));

        document.body.style.overflow = 'auto';
    
    }

}